module.exports = __webpack_public_path__ + "149faf503e4f48cc347cef37bcca35ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/mask.png
// module id = 1583
// module chunks = 0